export default __webpack_public_path__ + "static/media/team (4).fbc5d18d.jpg";